import React from "react";
import useStyles from "./style";
import { Box, Flex, Grid, Text } from "@mantine/core";
import emarImg from "./../../images/eMARImage.png";
import { useMediaQuery } from "@mantine/hooks";

const FeaturesPage = () => {
  const { classes } = useStyles();


  const isMobileScreen = useMediaQuery("(max-width: 834px)");
  const isLabptopScreen = useMediaQuery("(max-width: 1024px)");

  return (
    <Box className={classes.InlinePadding}>
        <Grid gutter="lg" className={classes.MobileFlexDirection}>
          <Grid.Col
            span={isMobileScreen ? 12 : 6 || isLabptopScreen ? 6 : 6}
            m={"auto"}
          >
            <Flex direction='column' maw={560} gap={10}>
            <Text className={classes.featureHdng}>Features</Text>
            <Text className={classes.featureTitle}>
              Tailored Solution For Your Organization
            </Text>
            <Text className={classes.featureDiscription}>
              Ogiso understands that every healthcare practice is unique. That’s
              why our platform is customizable to meet the specific needs of
              your business, whether you're a small contractor or a large
              healthcare network. From billing and invoicing, to report
              generation, Ogiso has you covered.
            </Text>
            </Flex>
          </Grid.Col>
          <Grid.Col span={isMobileScreen ? 12 : 6 || isLabptopScreen ? 6 : 6}>
            <img src={emarImg} alt="emarImg" className={classes.img} />
          </Grid.Col>
        </Grid>
    </Box>
  );
};

export default FeaturesPage;
